import { Col, Form, Radio, Row, Select, Tooltip, Typography } from "antd";
import React, {
  Fragment,
  Ref,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { surgeryStaffProps } from "./config";
import residentialNurseService from "api/residentialNurse";
import { useAppDispatch } from "redux/hooks";
import { setListDoctor } from "redux/reducer/residentialNurse";
import { Notification } from "components/common";
import { doctor, nursing } from "./doctor-list-surgery";

export type PatientInfoRef = {
  getFormValue: () => any;
};

type Props = {
  dataPersonalInfo?: any;
  ref?: Ref<PatientInfoRef>;
  id?: string | number;
};

const PersonalInfo = React.forwardRef<PatientInfoRef, Props>((props, ref) => {
  const { dataPersonalInfo } = props;
  console.log("🚀 ~ PersonalInfo ~ dataPersonalInfo:", dataPersonalInfo);

  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [surgeryStaff, setSurgeryStaff] = useState([]);
  const [valueRadio, setValueRadio] = useState(1);

  const getLitSurgeryStaff = async () => {
    try {
      const res = await residentialNurseService.getLitSurgeryStaff();

      setSurgeryStaff(res);
      dispatch(setListDoctor(res));
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách nhân sự phẫu thuật"
      );
    }
  };

  useEffect(() => {
    getLitSurgeryStaff();
  }, []);

  useEffect(() => {
    const parseBBhoiCHan = JSON.parse(
      JSON.parse(dataPersonalInfo?.bienBanHoiChan ?? null)
    );

    const parseredData =
      parseBBhoiCHan && parseBBhoiCHan[parseBBhoiCHan?.length - 1]?.data;

    if (parseredData) {
      form.setFieldValue(
        ["bacSiPhauThuat", "list"],
        dataPersonalInfo?.bacSiPhauThuat ?? [`${parseredData?.phauThuatVien}`]
      );
      form.setFieldValue(
        ["bacSiPhauThuat", "soLuongBacSi"],
        dataPersonalInfo?.soLuongBacSi ?? 1
      );
      setValueRadio(1);
    }
  }, [dataPersonalInfo]);

  useEffect(() => {
    if (dataPersonalInfo) {
      form.resetFields();
      form.setFieldsValue(dataPersonalInfo?.nhanSuPhauThuat);
    } else form.resetFields();
  }, [dataPersonalInfo]);

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      const rawValues = form.getFieldsValue();

      return rawValues;
    },
  }));

  return (
    <div className="personel-info">
      <Form form={form}>
        <Row gutter={[16, 8]}>
          {surgeryStaff.map((item) => (
            <Fragment key={item.id}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  name={[item.name, "soLuongBacSi"]}
                  label={
                    <Tooltip title={item.title} placement="top" arrow={false}>
                      <Typography.Text ellipsis={true}>
                        {item.title}
                      </Typography.Text>
                    </Tooltip>
                  }
                  labelAlign="left"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                >
                  <Radio.Group defaultValue={0}>
                    <Radio value={0} disabled>
                      0
                    </Radio>
                    <Radio disabled value={1}>
                      1
                    </Radio>
                    <Radio disabled value={2}>
                      2
                    </Radio>
                    <Radio disabled value={3}>
                      3
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item name={[item.name, "list"]}>
                  <Select
                    mode="tags"
                    size={"large"}
                    style={{ width: "100%" }}
                    options={item.list.map((i) => {
                      return {
                        value: i.name,
                        label: i.name,
                      };
                    })}
                    disabled
                    suffixIcon={
                      <Typography.Text className="select-suffix-label">
                        Danh sách
                      </Typography.Text>
                    }
                  />
                </Form.Item>
              </Col>
            </Fragment>
          ))}
        </Row>
      </Form>
    </div>
  );
});

export default PersonalInfo;
